import { render, staticRenderFns } from "./VSelectSearchable.vue?vue&type=template&id=6c1e45b3&"
import script from "./VSelectSearchable.vue?vue&type=script&lang=js&"
export * from "./VSelectSearchable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports